import { Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NO_EVENTS_DELAY_IMG } from 'src/defaultImages.js';

@Component({
  selector: 'app-no-delay-events-modal',
  templateUrl: './no-delay-events-modal.component.html',
  styleUrls: ['./no-delay-events-modal.component.css']
})
export class NoDelayEventsModalComponent implements OnInit {
  images = {
    NO_EVENTS_DELAY_IMG: NO_EVENTS_DELAY_IMG,
  }
  constructor(private _modalRef: NzModalRef) { }

  ngOnInit() {
  }

  gotItBtnClicked() {
    this._modalRef.close();
  }

}
